import axios from 'axios';
import { estimatePriorityFee } from './contractService';

const FUSION_BACKEND_API = process.env.REACT_APP_FUSION_BACKEND_API;

export const fetchFusionMaterials = async () => {
    let res;
    try {
        res = await axios.post(`${FUSION_BACKEND_API}/fusion/get-material-token-mapping`);
        if (res.status !== 200) {
            throw new Error("Not 200 response");
        } else {
            return res?.data?.result || {};
        }
    } catch(error) {
        console.log("Error:", error);
    }
}

export const fetchFusionItems = async (playerId, category) => {
    let res;
    const requestBody = {
        "playerId": playerId,
        "category": category,
    }

    try {
        res = await axios.post(`${FUSION_BACKEND_API}/fusion/get-items`, requestBody);
        if (res.status !== 200) {
            throw new Error("Not 200 response");
        } else {
            return res?.data?.result?.result || [];
        }
    } catch(error) {
        console.log("Error:", error);
    }
}

export const getFusionSignMessage = async (walletAddress, playerId, fingerprint, assetId, assestQty) => {
    try {
        const res = await fetch(`${FUSION_BACKEND_API}/fusion/nonce`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                walletAddress: walletAddress,
                fingerprint: fingerprint,
                playerId: playerId,
                assetId: assetId,
                quantity: assestQty,
            })
        });

        if (res.status !== 200) {
            throw new Error("Not 200 response");
        } else {
            return res.json();
        }
    } catch (err) {
        console.log(err);
    }
}

export const verifyFusionOrder = async (playerId, walletAddress, fingerprint, signature, signedMessage, assetId, assestQty) => {
    try {
        const res = await fetch(`${FUSION_BACKEND_API}/fusion/verify`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                playerId: playerId,
                walletAddress: walletAddress,
                fingerprint: fingerprint,
                signature: signature,
                signedMessage: signedMessage,
                assetId: assetId,
                quantity: assestQty,
            })
        });
        const obj = await res.json();

        if (res.status === 500 && obj?.message?.includes('Nonce-Mismatch')) {
            return "pending";
        }

        if (res.status !== 200) {
            return null;
        }

        return obj;
    } catch (err) {
        console.log(err);
    }
}

export const setTowerInventoryAllowance = async (towerInventoryContract, selectedAccount, spenderAddress, web3) => {
    try {
        let toBN = web3.utils.toBN;
        let gasPrice = await web3.eth.getGasPrice();
        let gasPriceBN = toBN(gasPrice);
        let gasEstimate = await towerInventoryContract.methods
            .setApprovalForAll(spenderAddress, true)
            .estimateGas({from: selectedAccount});
        let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.3 * gasPriceBN))).toString();
        let estimatedPriorityFee = await estimatePriorityFee(web3);
        let finalMaxFeePerGas = toBN(finalGasPrice).add(toBN(parseInt(estimatedPriorityFee))).toString();

        let receipt = await towerInventoryContract.methods.setApprovalForAll(spenderAddress, true)
            .send({
                from: selectedAccount,
                gasLimit: gasEstimate,
                gasPrice: finalGasPrice,
                maxFeePerGas: finalMaxFeePerGas,
                maxPriorityFeePerGas: estimatedPriorityFee
            })
            .on('transactionHash', txHash => {
                console.log(`txHash: ${txHash}`);
            })
            .on('receipt', (receipt) => {
                console.log("receipt: ", receipt);
            });

        if (receipt.status === true) {
            return true;
        }
    } catch (err) {
        console.log(err);
        if (err.code === 4001) {
            console.error(`Error caught during approval transaction: ${err.message}`);
            return false;
        }
    }
}

export const fuseItems = async (contract, web3, selectedAccount, itemId, quantity, materialTokenIds, materialTokenAmounts, totalCost, fuseSignature, fusionPendingCallBack) => {
    try {
        const toBN = web3.utils.toBN;

        let isPaused = await contract.methods.paused().call();
        if (isPaused) {
            return;
        }

        let gasPrice = await web3.eth.getGasPrice();
        let gasPriceBN = toBN(gasPrice);
        let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.3 * gasPriceBN))).toString();
        let gasEstimate = await contract.methods.fuse(itemId, quantity, materialTokenIds, materialTokenAmounts, totalCost, fuseSignature).estimateGas({ from: selectedAccount });
        let estimatedPriorityFee = await (await estimatePriorityFee(web3)).toString();
        let finalMaxFeePerGas = toBN(finalGasPrice).add(toBN(parseInt(estimatedPriorityFee))).toString();

        const receipt = await contract.methods.fuse(itemId, quantity, materialTokenIds, materialTokenAmounts, totalCost, fuseSignature).send({
            from: selectedAccount,
            gasLimit: gasEstimate,
            maxPriorityFeePerGas: estimatedPriorityFee,
            maxFeePerGas: finalMaxFeePerGas
        })
            .on('transactionHash', (txHash) => {
                console.log(`Transaction hash obtained : ${txHash}`);
                if (fusionPendingCallBack) {
                    fusionPendingCallBack(txHash);
                }
            })
            .on('receipt', (receipt) => {
                console.log("receipt:", receipt);
            })

        if (receipt.status === true) {
            return true;
        }
    } catch (err) {
        console.error(`Transaction failed: ${err.message}`);
        if (err.code === 4001) {
            return "reject";
        }

        if (err?.message?.includes('not mined within 50 blocks')) {
            return "pending";
        }
    }
}

export const fetchFusionOrderHistory = async (playerId) => {
    let res;
    const requestBody = {
        "playerId": playerId,
    }

    try {
        res = await axios.post(`${FUSION_BACKEND_API}/fusion/history`, requestBody);
        if (res.status !== 200) {
            throw new Error("Not 200 response");
        } else {
            return res?.data?.result || [];
        }
    } catch(error) {
        console.log("Error:", error);
    }
}